import React from 'react';
import styled from 'styled-components'

const LAUNCH = styled.button`
padding: 1rem 2rem 1rem 2rem;
color: white;
background: rgba(38, 20, 49, 1);
border-radius: 2rem;
font-size: 1rem;
margin-top: 3rem;
border:none;
outline: none;
cursor: pointer;
margin-top:.4rem;
align-self:center;
// margin-left: 1rem;
`
const CBtn = ({name, left}) => {
    const styler = {
        marginLeft: left
    }
    return ( 
        <>
<LAUNCH style={styler}>
    {name}
</LAUNCH>
        </>
     );
}
 
export {CBtn, LAUNCH};